import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { fuseAnimations } from '@fuse/animations';
import { AppInitializationService } from 'app/app-initialization.service';
import { Envanter } from 'app/models/envanter.model';
import { User } from 'app/models/user.model';
import { EnvanterService } from 'app/services/envanter.service';
import { ConfirmationDialogComponent } from 'app/services/user-interaction/components/confirmation-dialog/confirmation-dialog.component';
import { ToasterService } from 'app/services/user-interaction/services/toaster.service';
import { cloneDeep } from 'lodash';
import { NgxSpinnerService } from 'ngx-spinner';
import { GenericMapComponent } from '../../generic-map/generic-map.component';
import { EnvanterFormComponent } from '../envanter-form/envanter-form.component';

@Component({
  selector: 'app-envanter-list',
  templateUrl: './envanter-list.component.html',
  styleUrls: ['./envanter-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations,
})
export class EnvanterListComponent implements OnInit {


    @ViewChild(MatSort) private _sort: MatSort;
    @ViewChild(MatPaginator) private _paginator: MatPaginator;
    
    private _filterText: string = '';
    public get filterText(): string {
        return this._filterText;
    }
    public set filterText(v: string) {
        this._filterText = v.trim().toLowerCase();
        this._dataSource.filter = this._filterText;
    }

    private _dataSource: MatTableDataSource<Envanter> = undefined;
    public get dataSource(): MatTableDataSource<Envanter> {
        return this._dataSource;
    }

    private _displayedColumns = ['id', 'name', 'type', 'latitude','icon', 'description', "setting"];

    public get displayedColumns(): Array<string> {
        return this._displayedColumns;
    }

    public user: User;
    public envanterList: Array<Envanter>;

    constructor(
        private _envanterService: EnvanterService,
        private _dialog: MatDialog,
        private appConfigService:AppInitializationService,
        private _spinner: NgxSpinnerService,
        private _toastService: ToasterService,
    ) {}

    async ngOnInit() {
        await this.getEnvanter()
    }

    public async getEnvanter() {

        try {
            this._spinner.show('loading');
            this.envanterList = await this._envanterService.getEnvanter(parseInt(localStorage.getItem("CompanyID")));
            
            this._spinner.hide('loading');
        } catch (error) {
            this._spinner.hide('loading');
            console.warn(error);

        }
        await this.updateTableDataSource();
    }

    private async updateTableDataSource(): Promise<void> {

        this._dataSource = new MatTableDataSource<Envanter>(this.envanterList);
        this._dataSource.paginator = this._paginator;
        this._dataSource.sort = this._sort;

    }
    public async onEnvanterMap(element:Envanter){
        const dialog = this._dialog.open(GenericMapComponent,{
        })
        dialog.componentInstance.latitude=element.latitude;
        dialog.componentInstance.longitude=element.longitude;
    }

    update(envanter: Envanter) {

        const dialog = this._dialog.open(EnvanterFormComponent, {
            data: envanter,
            disableClose: false
        });
        dialog.componentInstance.envanter = cloneDeep(envanter);
        dialog.componentInstance.selectedCompany = cloneDeep(envanter.companyId);
        dialog.componentInstance.operation = "update";
        dialog.componentInstance.updated.subscribe((model: boolean) => {
            model ? this._toastService.toastSuccess() : this._toastService.toastFail();
            this.refresh();
            dialog.close();
        });

    }

    async deleteEnvanter(envanter: Envanter) {
        try {
            const dialog = this._dialog.open(ConfirmationDialogComponent,{

            })
            dialog.componentInstance.message = "Seçilen envanteri silmek istediğinize emin misiniz?"
            dialog.componentInstance.confirmed.subscribe(async(x)=>{
                await this._envanterService.delete(envanter)
                dialog.close();
            })
            dialog.componentInstance.rejected.subscribe(async (x:any) => {
                dialog.close();
            })
            
            this.refresh();
        } catch (error) {
            this._spinner.hide('loading');
            console.warn(error);
        }

    }

    refresh() {
        this.getEnvanter();
    }
}
